module.exports = __webpack_public_path__ + "static/media/lk.96cf4c4f.svg";